export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 250;
export const SIDE_NAV_COLLAPSED_WIDTH = 80;
export const SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT';
export const SIDE_NAV_DARK = 'SIDE_NAV_DARK';
export const NAV_TYPE_SIDE = 'SIDE'
export const NAV_TYPE_TOP = 'TOP'
export const DIR_LTR = 'ltr'
export const DIR_RTL = 'rtl'

export const MAX_NURSING_UNDER = 5;
export const MAX_PATIENT_HEALTH = 3;
export const MAX_APPOINTMENT = 3;
export const MAX_NUTRITIONS = 3;
export const DOCTOR_DOCUMENT_PATH = "/Doctors/introduce/";
export const DOCTOR_DOCUMENT_FILE_NAME = "doctor_document";
export const ROLE_DOCTOR = "0";
export const ROLE_NURSING = "1";
export const HEALTH_RECORD_PATH = "/HealthRecordPDF/";
export const HEALTH_RECORD_FILE_NAME = "Health_record";
export const MEDICINES_NUTRITION_PATH = "/Medicines/Nutrition/";
export const MEDICINES_LIFE_STYLE_PATH = "/Medicines/LifeStyle/";
export const DOCTOR_TYPE_LIST = [
    { value: "0", label: "Bác Sĩ" },
    { value: "1", label: "Y Tá" }
]

export const GENDER_TYPE_LIST = [
    { value: "Nam", label: "Nam" },
    { value: "Nữ", label: "Nữ" }
]

export const APPOINTMENT_STATUS = [
    { value: "0", label: "Đã Hẹn" },
    { value: "1", label: "Đã Xong" },
    { value: "2", label: "Đã Hủy" }
]

export const ORDER_STATUS = [
    { value: "created", title: "order.status.created" },
    { value: "confirm", title: "order.status.confirm" },
    { value: "prepare-order", title: "order.status.prepare" },
    { value: "delivery-agent", title: "order.status.delivery" },
    { value: "shipping-inprogress", title: "order.status.shipping" },
    { value: "complete", title: "order.status.completed" }
]

export const TREATMENT_GUIDLINES_PATH = "/TreatmentGuidelines/";

export const rules: any = {
    name: [
        {
            required: true,
            message: 'Please enter name',
        }
    ],
    numberFormat: [
        () => ({
            validator(_: any, value: any) {
                if (isNaN(value)) {
                    return Promise.reject("Please enter number");
                }
                return Promise.resolve();
            },
        }),
    ],
    numberFormatRequire: [
        {
            required: true,
            message: "Please enter this field",
        },
        () => ({
            validator(_: any, value: any) {
                if (isNaN(value)) {
                    return Promise.reject("Please enter number");
                }
                return Promise.resolve();
            },
        }),
    ],
    email: [
        {
            required: true,
            type: "email",
            message: "Please enter email",
        }
    ],
    textRequire: [
        {
            required: true,
            whitespace: true,
            message: 'Please enter this field',
        }
    ],
    dateTimePicker: [
        { type: 'object' as const, required: true, message: 'Please select time!' }
    ]
}

export const HTML_CONSTANT_REPLACE = '##replace##';
export const HTML_NEWS_DEFAULT = '<!DOCTYPE html> <html><head><meta name="viewport" content="width=device-width, initial-scale=1.0"><style> .preview-news p{font-size: 30px;} .preview-news h1 {font-size: 50px;text-align: center;} .preview-news h2 {font-size: 55px;} .preview-news h3 {font-size: 45px;} .preview-news li {font-size: 30px;} </style></head><body><img src="https://lh3.googleusercontent.com/fife/AGXqzDnnlFS3YI0lgj8H0i_9YN_vHMG43zaneYMPH72bDhiFDVA1Bua9DAD-Vj8WqIa2j8-1cDg4hjuAwNIDQfWWJ2fJvS9ygWwuhM3gtwryRTXF3zCMtTIcCqsG64qC0jS4WPXwWfHvV3TUXpxgC9Ov-AYhLewcGxReYxAnkI4zx__xtakgrayKMGqyGdYNdONeIeZM_yIgDuil_R3uVLkw6fkpV1AIGpQyBrm9YJn7g91XRdc0PR99Lx88AB-UitZxsSJK0hEktj2XGPBUTrNBNn3H3eBtLU3bFosAoFUQtUvyuPqDsHxpOzTLBixh45hs83Lwh-Dj5IjGsXCtA3fZkjpD60DXlwHw6MhGrCiKF2lZ-mIuIvSc6X2AJcacJoMkzvtYf9SNQNd4cO5NxbKbx46nM7N0c3lAozDbb1iGiJk8i_ydIVA_JbR-qXgX8Fn8pmmSQA9NJC5zDiDx10boUnzCPf3EGcIB2y3JiNDupUp_W8KmJD3tOmFfcbiYGqw2fv9Hm8HXjYAsp1edZZG68SFepBrVBfdiNnX7xBjZhNljVmBKq9rGK7ofzkHSOtb2dLyvxHFOY-s1MkxiAqsMPj_bw2QqJ_JFRG0peFd5YYZBG_VA4FE2c2GBTjOCUJyKAw_2Bm2b_4w9M69msA5gLDqszhRx-qIH6psvZpjJ5r6EZgKbZCqzjEJm2aW5cKJIlvpQj9RhLjox9nMLG8ZLQO3bOmKFBHg0l4i5dZcg-VFcc3025kcWpMaz2P_bmTfLOY28rajQleulGUUZHH5UVjUZ40xrRvTGcoPFs0XzL5FqE2nHciEE18Ys13W92oYbgyREDHUYWertK7dcYem5eeAql1sEAywZuLBnjvlTPUa8dVRfhBRM_DzZyPI7eo78YxiKdwGhgZoX8UWwbx3QLMv1D1KTXjpz67ZRtGIH__L16UPWj-lcsY1t0V01O8lEA_p5UIOALOBdeh_GbGmBp_S2IFGiERe_TKazGfRmoQWqJOUwQldv4ieXVKIxZz1nk35ZgSiQ3Sx-xe72SwMOxu6NMED4CKj5u_LYamcN0w4hbW8QCY-vHfOFHMQjHjYAbbWr7JNxXQMmCYQG_Q8ncdnxlarhrHmInOZ7KrBCmv9MJ7JLow56Luxfhzs156klPyvsun4Nl9_5spjy1JU3dZykVTUoFqqxdbY19KfFfSAA1fJ7JCYGYZ6YMYyWEkqYc190q4199dvG__qm8Y3vceQOCeYXm0j4tgFa40HpTa_O4s-S6pBlbIipGfuPt5cMDvplDGsFiYMslf9fKQl2xj_hbwaDmbMpRLUfcIu2wZF5sV66_K65tOWIwMUV1rIHzM8VfEtFo7Z8cwaV9Wn4lvLXIoIxoc91JBXaTSQOsFZSkek93CDHZzHw94pRaYA6cLOU1aoRb5yIRvwWHVJO76IrDMWLwvFn35tgA8v1Paiu6bhJ-2-UAyIgXGjPrjQHKQ68RkFOXvXyWjbRKvST9ALCZxpAuz6zKnQIIkjDC7jyHeHT1YwlFXXBHf4UFnOSXhW_32ON6qi_ejub0_WS8kFu-NSBVNndNYzVlytP_UwFWSq9sjbr6Gze3EIFxXsaY3Vr78SNy6wWktsCbLn8noCQ7JPRZSLaJD3n4K822E8pO58uYUXUBGnTxWhexVpzIBOCzpAhavtqBkSyLzm4J0I2GWPE3kLiwcPtOOfvIA=w2560-h1312" alt="header" width="35%" height="auto">##replace##</body></html>';